<template>
  <div>
    <el-table :data="records" v-loading="records.length === 0" :height="tableHeight">
      <el-table-column align="center" label="操作时间" prop="createTime" width="120">
        <template #default="{row}">
          {{new Date(row.createTime.replace(/-/g, '/')).format('yyyy-MM-dd hh:mm')}}
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作人" prop="operatorName"></el-table-column>
      <el-table-column align="center" label="工序" prop="curProcedureName">
        <template #default="{row}">
          <div>{{row.curProcedureName | trim}}{{statusText(row.curWorkStatus)}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="内容" prop="content"></el-table-column>
    </el-table>
  </div>
</template>

<script>
  import { resizeCaptureMixin } from '@/views/mixins/ResizeCapture'

  export default {
    name: 'WxOperaRecordPanel',
    mixins: [resizeCaptureMixin],
    props: {
      records: Array
    },
    methods: {
      statusText (status) {
        switch (status) {
          // case 'WAIT_CONFIRM':
          //   return ' - ' + '待确认'

          case 'WAIT':
            return ' - ' + '待施工'
        }
        return ''
      }
    },
    computed: {
      tableHeight () {
        return this.clientHeight - 190
      }
    }
  }
</script>
